import { ApproverSettings } from 'types'

export const GLOBAL_APPROVERS = ['UMU21GS7Q']
export const DIGITAL_APPROVERS = [
  'U06LJAMPWJ1', // Thomas Ziolkowski
  'U01FK2W9YNS', // Ryan Dixon
]
export const CREATIVE_APPROVERS = [
  'UPH8S2B9B', // Philip Sanford
  'U03RWJJ4LRJ', // Brooke Santana
  'U01HSHDCFHU', // Anna Sella
]
export const WEBSITE_APPROVERS = [
  'UPH8S2B9B', // Philip Sanford
]
export const SEO_LAUNCHPAD_APPROVERS = [
  'U01FK2W9YNS', // Ryan Dixon
  'U015KLM51B6', // Patric Cavanaugh
]
export const MSA_HOUSING_APPROVERS = []
// 'U015KLM51B6', // Patric Cavanaugh
// 'UHKAA49CJ', // Justin Widmayer
// 'U062JDP8R5X', // Colin Cavanaugh
export const INITIAL_STATE = {
  creative: [...GLOBAL_APPROVERS, ...CREATIVE_APPROVERS],
  msa: [...GLOBAL_APPROVERS, ...DIGITAL_APPROVERS],
  seo: [...GLOBAL_APPROVERS, ...SEO_LAUNCHPAD_APPROVERS],
  website: [...GLOBAL_APPROVERS, ...WEBSITE_APPROVERS],
  housing: [...GLOBAL_APPROVERS],
}
export const categoryToKey = (category: string): keyof ApproverSettings => {
  switch (category) {
    case 'Creative':
      return 'creative'
    case 'Website':
      return 'website'
    case 'SEO':
    case 'LaunchPad':
      return 'seo'
    case 'Digital':
      return 'msa'
    default:
      return 'msa'
  }
}
